import ContactHero from "../components/ContactHero";
import ContactSection from "../components/ContactSection";

function Contact() {
  return (
    <>
      <ContactHero />
      <ContactSection />
    </>
  );
}

export default Contact;
